module.exports = __intlLocaleData;